module.exports = __webpack_public_path__ + "static/img/logo-4-1.c2c7ebfc.png";